import { apiClient } from './client';

export const testimonialsApi = {
    getAll: () => apiClient.get('/testimonials'),
    getById: (id) => apiClient.get(`/testimonials/${id}`),
    create: (data) => apiClient.post('/testimonials', data),
    update: (id, data) => apiClient.put(`/testimonials/${id}`, data),
    delete: (id) => apiClient.delete(`/testimonials/${id}`),
};
